import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as Authorization from '../../lib/authorization';
import * as AppState from '../../state/reducer/app/appState';
import DialogFactory from '../factory/DialogFactory';

import Console from '../../lib/debug';
import { FEATURES } from '../../v5/features/components/constants';

class UnauthorizedDialog extends Component {
    redirectToBilling = () => {
        const { features } = this.props;

        AppState.hideUnauthorizedDialog();

        if (features[FEATURES.COACH_PRICING]) {
            return (window.location =
                Authorization.navigateToSubscriptionPlans.path);
        }

        return (window.location =
            Authorization.navigateToLegacySubscriptionPlans.path);
    };

    handleDialogClose = () => {
        AppState.hideUnauthorizedDialog();
    };

    render() {
        Console.render('UnauthorizedDialog');
        const unauthorizedText = `Sorry, this feature isn't allowed with your 
            current subscription. Would you like to upgrade to access it?`;

        return (
            <DialogFactory
                enabled={this.props.enabled ? true : false}
                handleClose={this.handleDialogClose}
                handleSave={this.redirectToBilling}
                header="Upgrade to Access this Feature"
                text={unauthorizedText}
                cancelButtonTitle="No Thanks"
                saveButtonTitle="Learn More"
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        enabled: state.app.unauthorizedDialogOpen,
        features: state.features
    };
};

export default connect(mapStateToProps)(UnauthorizedDialog);
